import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import FlexWrapper from '../FlexWrapper';
import Divider from '../../components/Divider';
import SuggestionMessage from '../../components/EmptyMessage/SuggestionMessage';
import "./ActiveWorkflows.scss"

const DataSynchronisationCoverage = ({ data, displayMode }) => {
	const [expandedFunds, setExpandedFunds] = useState([])
	const [coverageComponent, setCoverageComponent] = useState("Missing")

	const progressCurrent = data && data.uploadStatus && data.uploadStatus.filter(fund => fund.uploadStatus === 'IMPORTED')
	const progressTotal = data && data.uploadStatus && data.uploadStatus.length

	function getFilteredFunds(status) {
		return data && data.uploadStatus
			? data.uploadStatus
				.filter(fund => fund.uploadedData && fund.uploadedData.some(uploadData => uploadData.uploadStatus === status))
				.map(fund => ({
					...fund,
					uploadedData: fund.uploadedData.filter(uploadData => uploadData.uploadStatus === status),
				}))
			: [];
	}

	function getFilteredGroups(status) {
		return data.groupStatus && data.groupStatus.filter(group => {
			if (status === "MISSING") {
				return group.completed !== group.total
			}
			if (status === "IMPORTED") {
				return group.completed === group.total
			}
		})
	}

	const filteredFunds = coverageComponent === "Missing" ? getFilteredFunds('MISSING') : getFilteredFunds('IMPORTED');
	const viewableFunds = filteredFunds && filteredFunds.length > 0 ? filteredFunds : [];
	const filteredGroups = coverageComponent === "Missing" ? getFilteredGroups("MISSING") : getFilteredGroups("IMPORTED");
	const viewableGroups = filteredGroups && filteredGroups.length > 0 ? filteredGroups : [];

	function toggleRowExpansion(fundId) {
		let expansionList = [...expandedFunds];
		if (expandedFunds.includes(fundId)) {
			expansionList = expansionList.filter((id) => id !== fundId)
		} else {
			expansionList = [...expansionList, fundId]
		}
		setExpandedFunds(expansionList)
	}

	return !data ? (
		""
	) : (
		<FlexWrapper gap="s" direction="column" justify="start" align="start" style={{ marginBottom: "1rem" }}>
			<FlexWrapper gap="l" style={{ marginBottom: "0.5rem" }}>
				<p style={{ fontWeight: 600 }}>Coverage: {progressCurrent.length}/{progressTotal}</p>
			</FlexWrapper>
			<FlexWrapper gap="m" className={`mb-m`}>
				<p
					className={`coverage-component-selector ${coverageComponent === "Missing" ? "active-coverage" : ""}`}
					onClick={() => setCoverageComponent("Missing")}
				>
					Missing
				</p>
				<p
					className={`coverage-component-selector ${coverageComponent === "Completed" ? "active-coverage" : ""}`}
					onClick={() => setCoverageComponent("Completed")}
				>
					Completed
				</p>
			</FlexWrapper>

			{(viewableFunds.length === 0) ? (
				<SuggestionMessage message="No data to display" />
			) : (
				<FlexWrapper direction="column" align="start" style={{ width: "100%", paddingBottom: '6rem' }}>
					<div className="worflow-data-synchronisation-task">
						{displayMode === "GROUP"
							? coverageComponent === "Missing"
								? <RenderGroups groups={viewableGroups} groupClass={"missing-fund"} />
								: <RenderGroups groups={viewableGroups} groupClass={"succeeded-fund"} />
							: coverageComponent === "Missing"
								? <RenderFunds funds={viewableFunds} fundClass={"missing-fund"} dividerColor={"danger-dark"} expandedFunds={expandedFunds} toggleRowExpansion={toggleRowExpansion} />
								: <RenderFunds funds={viewableFunds} fundClass={"succeeded-fund"} dividerColor={"positive-dark"} expandedFunds={expandedFunds} toggleRowExpansion={toggleRowExpansion} />
						}
					</div>
				</FlexWrapper>
			)}
		</FlexWrapper>
	);
}

const RenderFunds = ({ funds, fundClass, dividerColor, expandedFunds, toggleRowExpansion }) => {
	return funds.map((fund, idx) => (
		<React.Fragment key={`${fundClass}-fund-${idx}`}>
			<FlexWrapper key={`${idx}-FlexWrapper`} onClick={() => toggleRowExpansion(fund.fundId)} direction="column" align="start">
				<FlexWrapper className={`${fundClass}`}>
					{fund.name} ({fund.uploadedData.length})
					{expandedFunds.includes(fund.fundId) ? <ChevronUp /> : <ChevronDown />}
				</FlexWrapper>
				{expandedFunds.includes(fund.fundId) && (
					<FlexWrapper className={`${fundClass}-data`} direction="column" align="start">
						{fund.uploadedData.map((file, idx) => {
							const formattedString = file.type.includes("_")
								? file.type.split("_").join(" ").toLowerCase()
								: file.type.toLowerCase();
							return (
								<React.Fragment key={`${fundClass}-expanded-${idx}`}>
									<div style={{ textTransform: "capitalize" }}>{formattedString}</div>
									{idx + 1 !== fund.uploadedData.length && (
										<Divider colour={dividerColor} opacity="0.2" />
									)}
								</React.Fragment>
							);
						})}
					</FlexWrapper>
				)}
			</FlexWrapper>
		</React.Fragment>
	));
};

const RenderGroups = ({ groups, groupClass }) => {
	return groups.map((group, idx) => (
		<React.Fragment key={`${groupClass}-group-${idx}`}>
			<FlexWrapper key={`${idx}-FlexWrapper`} direction="column" align="start">
				<FlexWrapper className={`${groupClass}`}>
					{group.offerName} {groupClass === "missing-fund" ? `${group.completed}/${group.total}` : `(${group.completed})`}
				</FlexWrapper>
			</FlexWrapper>
		</React.Fragment>
	));
};




export default DataSynchronisationCoverage;

